function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3586",
  "data-name": "Group 3586",
  transform: "translate(-326 -231)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: "26",
  cy: "26",
  r: "26",
  transform: "translate(326 231)",
  fill: "#83cb53"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3595",
  "data-name": "Group 3595",
  transform: "translate(-523 -346)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_667",
  "data-name": "Group 667",
  transform: "translate(860 588)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M0 0h30v30H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_400",
  "data-name": "Path 400",
  d: "M17.6 12.481l3.9-2.942v7.846l-3.9-2.942v2.942H8.5V9.538h9.1zM6.892 21.308H25.4V5.615H4.6v17.5zm.9 2.615L2 28.5V4.308A1.3 1.3 0 013.3 3h23.4A1.3 1.3 0 0128 4.308v18.307a1.3 1.3 0 01-1.3 1.308z",
  fill: "#fff"
}))))));